module.exports = __webpack_public_path__ + "static/media/image.357e825b.svg";